import React from "react";

export default function HeaderAccount({ apending, executed, rejected }) {
  return (
    <div className="px-5 py-3 text-[14px] space-y-1 text-[var(--text)] dark:text-gray-200">
      <div className="flex justify-between">
        <span>Pending :</span>
        <span className={`font-semibold text-[var(--text)]`}>
          {parseFloat(apending).toFixed(2)}
        </span>
      </div>
      <div className="flex justify-between">
        <span>Executed :</span>
        <span className={`font-semibold text-[var(--buymeta)]`}>
          {parseFloat(executed).toFixed(2)}
        </span>
      </div>
      <div className="flex justify-between">
        <span>Rejected :</span>
        <span className={`font-semibold text-[var(--sellmeta)]`}>
          {parseFloat(rejected).toFixed(2)}
        </span>
      </div>

    </div>
  );
}
